import { useMemo } from 'react';

import type { SelectOption } from '@swf/components/Inputs/components/DropDown/DropDown';

import type { OptionsFilter } from '../utils/common';
import { fallback } from '../utils/common';

const useGetPlayersPerTable = ({ gameData, values }: OptionsFilter): SelectOption[] =>
  useMemo(() => {
    if (!gameData || !gameData.length) return fallback;

    const { handType, potStruct } = values;
    const data = gameData.filter(
      (item) => item.handType === handType && item.potStruct === potStruct
    );

    const options = [...new Set(data.map((item) => Number(item.tableSize)))]
      .sort((a, b) => b - a)
      .map((tableLimit) => ({ text: tableLimit, value: tableLimit }));

    if (!options || !options.length) return fallback;

    return options;
  }, [gameData, values]);
export default useGetPlayersPerTable;
